// extracted by mini-css-extract-plugin
module.exports = {"table":"ExcelViewer_table__01K_T","headerCell":"ExcelViewer_headerCell__5TFn7","cell":"ExcelViewer_cell__HGWVZ"};